import React from "react"
import CustomAlert from "../../../../../ui/atoms/Alert"
import Loader from "../../../../../ui/atoms/Loader"
import { CustomBox, CustomCol, CustomRow } from "../../../../../ui/spacings"
import { EditorialLabel } from "../../../../contents"
import { useCheckout } from "../../../state/hooks"
import EmptyBasket from "../../common/EmptyBasket"

export interface BasketWrapperProps {
  children: any
}

const BasketWrapper = ({ children }: BasketWrapperProps) => {
  const { basket, initialized } = useCheckout()
  return (
    <>
      {!initialized && (
        <CustomRow justify="center">
          <CustomCol xs={12} sm={6}>
            <CustomBox px={2} my={4} textCenter>
              <Loader />
            </CustomBox>
          </CustomCol>
        </CustomRow>
      )}
      {initialized && (!basket || basket.empty) && (
        <CustomRow justify="center">
          <CustomCol xs={12} sm={6}>
            <CustomBox px={2} my={4} textCenter>
              <CustomAlert
                severity="warning"
                show={(basket?.unavailableItems?.length ?? 0) > 0}
              >
                <EditorialLabel scope="basket" id="articles-not-available" />
              </CustomAlert>
              <EmptyBasket />
            </CustomBox>
          </CustomCol>
        </CustomRow>
      )}
      {basket && !basket.empty && children}
    </>
  )
}

export default BasketWrapper
